const newsDetailPushTarget  = (tab) => {
    if (tab.indexOf('News') !== -1) {
        return 'news/detail'
    }

    if (tab.indexOf('Alliance') !== -1) {
        return 'techFinance/detail'
    }

    if (tab.indexOf('PolicyConsult') !== -1) {
        return 'policy/more/0/政策咨询/detail'
    }

    if (tab.indexOf('Business') !== -1) {
        return 'bussiness'
    }
};

export default newsDetailPushTarget
